import React, { useState, useRef, useEffect } from "react";
import produce from 'immer';
import auth from "../auth";
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import { useTranslation } from 'react-i18next';
import { Transition } from "extras";
import Version from "version";
import useWindowDimensions from "../hooks/useWindowDimensions";
import ServerState from '../controls/ServerState';
import ReactLoading from 'react-loading';
import { useConnect } from 'dotnetify';
import MasonryLayout from 'controls/MasonryLayout';
import { useTheme } from '@material-ui/core/styles';
import { Grid, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Icon from "../components/Selfcare/Common/Icon";
import PrepaidContainer from '../controls/PrepaidContainer';
import PotContainer from '../controls/PotContainer';
import TopContainer from '../controls/TopContainer';
import { Box, BoxTitle, BoxContent } from '../controls/Box';
import { LargeButton, SmallButton } from '../controls/components/Buttons';
import SparkleDialog from '../controls/components/SparkleDialog';
import { Link } from 'react-tiger-transition';
import viaplayLogo from '../assets/img/viaplay.png';

export default function Home() {
    const { t } = useTranslation();
    const { vm, state } = useConnect("Home", { PaymentDialogOpen: false }, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        vmArg: {
            HostUrl: window.location.host,
            Path: window.location.pathname,
        },
        exceptionHandler: _ => auth.signOut()
    });
    const [localState, internalSetLocalState] = useState({ disabled: false, busy: false, showBuyDataButton: false, dialogOpen: false, ViaplayBuzy: false, CancelViaplayDialogOpen: false });
    const setLocalState = (o) => {
        internalSetLocalState(
            produce(draft => {
                draft[Object.keys(o)[0]] = Object.values(o)[0];
            })
        )
    }
    useEffect(() => {
        if (state.pInfo) {
            gstate.paymentInfo.set(state.pInfo);
        }
        if (state.GoNets)
            window.location.replace(state.GoNets);
        if (state.StateName)
            setLocalState({ [state.StateName]: state.StateValue });
    }, [state.GoNets]);
    const gstate = useGlobalState(globalState);
    const theme = useTheme();
    const wDim = useWindowDimensions();
    const dialogRef = useRef();
    const handleOpenPostpaidTopupDialog = () => {
        dialogRef.current.showDialog("postpaidTopup");
    }
    const handleOpenPrepaidTopupDialog = () => {
        dialogRef.current.showDialog("prepaidTopup");
    }
    const handleOpenChargePrepaidDialog = () => {
        dialogRef.current.showDialog("chargePrepaid");
    }
    const handleChangeDataLevel = () => {
        dialogRef.current.showDialog("changeSubscriptionDataLevel");
    }
    if (sessionStorage.getItem("Firstname") !== null) {
        gstate.Firstname.set(sessionStorage.getItem("Firstname"));
        sessionStorage.removeItem("Firstname");
        gstate.PackageType.set(sessionStorage.getItem("PackageType"))
        sessionStorage.removeItem("PackageType");
    }
    const handleRefresh = () => {
        vm.$dispatch({ Refresh: true });
    }
    const handlePaymentDialogClose = () => {
        vm.$dispatch({ PaymentDialogOpen: false });
    }
    const SafeMasonryLayout = ({ children, ...props }) => <MasonryLayout {...props}>{[].concat(children).filter(Boolean)}</MasonryLayout>
    return (
        <>
            <ServerState serverState={state} localState={localState} setLocalState={setLocalState} />
            <SparkleDialog ref={dialogRef} handleRefresh={handleRefresh} />
            <Dialog
                open={state.PaymentDialogOpen}
                onClose={handlePaymentDialogClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">
                    <Icon name="credit-card" size={36} color={theme.palette.primary.main} />
                    {state.PaymentDialogType === "pay" &&
                        <span style={{ marginLeft: '20px' }}>{t('selfcare:title.make-payment')}</span>}
                    {state.PaymentDialogType === "invoice" &&
                        <span style={{ marginLeft: '20px' }}>Betala faktura med kort</span>}
                </DialogTitle>
                <DialogContent>
                    {state.Subscription && (state.Subscription.cardInfo || state.PaymentDialogType === "invoice") && <Grid container style={{ color: '#000', fontSize: '1rem' }}>
                        {state.Subscription?.cardInfo &&
                            <Grid item xs={12} sm={6}>
                                <div style={{ textTransform: 'uppercase' }}>
                                    {t('selfcare:label.card-number')}
                                </div>
                                <div>
                                    {state.Subscription?.cardInfo?.CardNo}
                                </div>
                                <div style={{ textTransform: 'uppercase', marginTop: '10px' }}>
                                    {t('selfcare:label.valid-to')}
                                </div>
                                <div>
                                    {state.Subscription?.cardInfo?.ValidTo}
                                </div>
                                <Icon name={state.Subscription?.cardInfo?.CardType} size={36} />
                            </Grid>}
                        <Grid item xs={12} sm={state.Subscription?.cardInfo ? 6 : 12}>
                            {state.PaymentDialogType === "pay" &&
                                <span dangerouslySetInnerHTML={{ __html: state.PaymentDialogText }} />}
                            {state.PaymentDialogType === "invoice" &&
                                <span dangerouslySetInnerHTML={{ __html: state.PaymentDialogText }} />}
                        </Grid>
                    </Grid>}
                </DialogContent>
                <DialogActions>
                    {state.PaymentDialogType === "pay" &&
                        <LargeButton onClick={() => vm.$dispatch({ ConfirmPayment: true })}>
                            {t('selfcare:button.accept')}
                        </LargeButton>}
                    {state.PaymentDialogType === "invoice" &&
                        <LargeButton onClick={() => vm.$dispatch({ ConfirmPayment: true })}>
                            Till kortbetalning
                            </LargeButton>}

                    <LargeButton variant="outlined" onClick={handlePaymentDialogClose}>
                        {t('selfcare:button.cancel')}
                    </LargeButton>
                </DialogActions>
            </Dialog>
            <Dialog
                disableBackdropClick
                open={localState.CancelViaplayDialogOpen}
                onClose={() => { setLocalState({ CancelViaplayDialogOpen: false }); setLocalState({ ViaplayBuzy: false }); }}
                style={{ zIndex: 3000 }}
            >
                <DialogContent style={{ justifyContent: 'center' }}>
                    <div style={{ fontSize: '1.5rem' }}>
                        Avsluta Viaplay
                        </div>
                    <div style={{ marginTop: '20px' }}>
                        {state.ViaplayOptOutConfirmText}
                    </div>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <LargeButton onClick={() => { vm.$dispatch({ CancelViaplayTrial: true }); setLocalState({ CancelViaplayDialogOpen: false }); setLocalState({ ViaplayBuzy: false }); }}>Bekräfta</LargeButton>
                    <LargeButton variant="outlined" onClick={() => { setLocalState({ CancelViaplayDialogOpen: false }); setLocalState({ ViaplayBuzy: false }); }}>Avbryt</LargeButton>
                </DialogActions>
            </Dialog>
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                open={localState.ActivateViaplayDialogOpen}
                onClose={() => { setLocalState({ ActivateViaplayDialogOpen: false }); } }
                TransitionComponent={Transition}
                transitionDuration={500}
                style={{ zIndex: 3000 }}
            >
                <DialogContent style={{ justifyContent: 'center' }}>
                    <div style={{ fontSize: '1.5rem' }}>
                        Registrera dig hos Viaplay
                    </div>
                    <div style={{ marginTop: '20px' }}>
                        Du behöver nu registrera dig hos Viaplay. Vi öppnar registreringen i ett nytt fönster.
                        </div>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center' }}>
                    <LargeButton onClick={() => { setLocalState({ ActivateViaplayDialogOpen: false }); dialogRef.current.openUrl(state.OpenUrl, true); }}>Till Viaplay</LargeButton>
                </DialogActions>
            </Dialog>
            <TopContainer bell logo noSelect>
                <div style={{ fontSize: '20px', fontWeight: 300 }}>{state.IsNorway ? 'Hei,' : 'Hej'} {gstate.Firstname.get()}!</div>
                {(state.IsPostpaid || state.IsData) &&
                    <PotContainer Pots={state.Pots} vm={vm} state={state} localState={localState} setLocalState={setLocalState} handleBuyData={handleOpenPostpaidTopupDialog} handleChangeDataLevel={handleChangeDataLevel} />}
                {state.IsPrepaid &&
                    <PrepaidContainer state={state} handleBuyData={handleOpenPrepaidTopupDialog} handleChargePrepaid={handleOpenChargePrepaidDialog} />
                }
                {state.ShowViaplayOptOut &&
                    <Box border>
                        <div style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: state.ViaplayOptOutText }} /></div>
                        <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                        <SmallButton id='register-viaplay' disabled={localState.ViaplayBuzy} onClick={() => { setLocalState({ CancelViaplayDialogOpen: true }); setLocalState({ ViaplayBuzy: true }); }}>
                                Avsluta Viaplay
                            </SmallButton>
                        </div>
                        {localState.ViaplayBuzy &&
                            <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                            </div>
                        }
                    </Box>
                }
                {state.ShowViaplayOffer &&
                    <Box border>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: state.ViaplayText }} /></div>
                            <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>

                                <SmallButton id='register-viaplay' disabled={localState.ViaplayBuzy} onClick={() => { vm.$dispatch({ AcceptViaplayOffer: true }); setLocalState({ ViaplayBuzy: true }); }}>
                                    Acceptera erbjudande
                                </SmallButton>
                                <SmallButton variant="outlined" disabled={localState.ViaplayBuzy} onClick={() => { vm.$dispatch({ AcceptViaplayOffer: false }); setLocalState({ ViaplayBuzy: true }); }}>
                                    Nej tack
                                </SmallButton>
                            </div>
                            {localState.ViaplayBuzy &&
                                <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                    <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                                </div>
                            }
                        </div>
                    </Box>
                }
                {
                    state.ShowActivateViaplay &&
                    <Box border>
                        <div style={{ textAlign: 'center' }}>
                            <div style={{ textAlign: 'left', fontSize: '0.875rem' }}><span dangerouslySetInnerHTML={{ __html: state.ViaplayText }} /></div>
                            <img style={{ width: '100px', marginBottom: '10px' }} src={viaplayLogo} alt="Viaplay" />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                                <SmallButton id='register-viaplay' disabled={localState.ViaplayBuzy} onClick={() => {
                                    vm.$dispatch({ ActivateViaplay: true }); setLocalState({ ViaplayBuzy: true }); dialogRef.current.openUrl(state.OpenUrl, true);
                                }}>
                                    {t('selfcare:button.activate-viaplay')}
                                </SmallButton>
                                <SmallButton variant="outlined" disabled={localState.ViaplayBuzy} onClick={() => { vm.$dispatch({ ActivateViaplay: false }); setLocalState({ ViaplayBuzy: true }); }}               >
                                    {t('selfcare:button.cancelorder')}l
                                </SmallButton>
                            </div>
                            {localState.ViaplayBuzy &&
                                <div style={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'center', width: '100%' }}>
                                    <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={'50px'} width={'50px'} />
                                </div>
                            }
                        </div>
                    </Box>
                }
                {
                    state.IsSweden && state.PaymentInfoMessage && state.HasCardRegistered &&
                    <Box border>
                        {state.PaymentInfoMessage}
                    </Box>
                }
                {
                    state.IsSweden && state.PaymentMessage && state.HasCardRegistered &&
                    <Box border>
                        {state.PaymentMessage}
                        <div style={{ textAlign: 'center', width: '100%' }}>
                            <SmallButton style={{ marginTop: '10px' }} onClick={() => vm.$dispatch({ SettleDebt: true })}>Betala {state.PaymentAmount}</SmallButton>
                        </div>
                    </Box>
                }
                {
                    state.IsSweden && state.PaymentMessage && state.InvoicePayment &&
                    <Box border>
                        {state.PaymentMessage}
                        <div style={{ textAlign: 'center', width: '100%' }}>
                            <SmallButton style={{ marginTop: '10px' }} onClick={() => vm.$dispatch({ PayInvoices: true })}>Betala {state.PaymentAmount} med kort</SmallButton>
                        </div>
                    </Box>
                }
                <SafeMasonryLayout columns={wDim.width > 759 ? 2 : 1}>
                    {state.IsNorway && state.IsPostpaid &&
                        <Box background fullWidth>
                            <BoxTitle>
                                Forbruk utover månedspris
                            </BoxTitle>
                            <BoxContent>
                                {!state.UnbilledAmountHTML ?
                                    <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={30} width={50} />
                                    :
                                    <Grid container direction="row" justify="space-between" alignItems="center" style={{ fontFamily: theme.typography.fontFamily }} dangerouslySetInnerHTML={{ __html: state.UnbilledAmountHTML }} />
                                }
                            </BoxContent>
                            <SmallButton component={Link} replace to="/invoice-list" transition="fade">Se mer</SmallButton>
                        </Box>}
                    {state.IsPrepaid && 1 === 2 &&
                        <Box background fullWidth>
                            <BoxTitle>
                                Forbruk siste 30 dager
                            </BoxTitle>
                            <BoxContent>
                                <Grid container direction="row" justify="space-between" alignItems="center" style={{ fontFamily: theme.typography.fontFamily }}><div>Väntar på data från Telia</div></Grid>
                            </BoxContent>
                            <SmallButton component={Link} replace to="/invoice-list" transition="fade">Se mer</SmallButton>
                        </Box>}
                    {state.IsPrepaid &&
                        <Box background fullWidth>
                            <BoxTitle>
                                Siste påfylling
                            </BoxTitle>
                            <BoxContent>
                                <Grid container direction="column" justify="center" alignItems="center" style={{ fontFamily: theme.typography.fontFamily }}>
                                    <Grid container direction="row" justify="space-between" alignItems="center" style={{ fontSize: '12px', fontWeight: 600 }}>
                                        <div>Beskrivelse</div>
                                        <div>Dato</div>
                                        <div>Beløp</div>
                                    </Grid>
                                    <Grid container direction="row" justify="space-between" alignItems="center" dangerouslySetInnerHTML={{ __html: state.RefillText }} />
                                </Grid>
                            </BoxContent>
                            <SmallButton component={Link} replace to="/invoice-list" transition="fade">Se mer</SmallButton>
                        </Box>}
                    {state.IsPrepaid &&
                        <Box background fullWidth weight={5}>
                            <BoxTitle>
                                Priser i Norge
                            </BoxTitle>
                            <BoxContent>
                                <Grid container style={{ fontFamily: theme.typography.fontFamily2, fontSize: '12px', lineHeight: '24px' }}>
                                    <Grid item xs={2}>Tale</Grid>
                                    <Grid item xs={8}>Minuttpris</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}>0,69</Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={8}>Oppstart</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}>0,99</Grid>
                                    <Divider style={{ width: '100%', marginBottom: '1px', marginTop: '1px' }} />
                                    <Grid item xs={2}>SMS</Grid>
                                    <Grid item xs={8}>Per stk.</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}>0,59</Grid>
                                    <Divider style={{ width: '100%', marginBottom: '1px', marginTop: '1px' }} />
                                    <Grid item xs={2}>MMS</Grid>
                                    <Grid item xs={8}>Per stk.</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}>1,29</Grid>
                                    <Divider style={{ width: '100%', marginBottom: '1px', marginTop: '1px' }} />
                                    <Grid item xs={2}>Data</Grid>
                                    <Grid item xs={8}>Per MB (uten datapakke)</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}>0,99</Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={8}>Makspris per dag</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}>15,00</Grid>
                                    <Grid item xs={2}></Grid>
                                    <Grid item xs={8}>(Maks bruk per dag 300 MB)</Grid>
                                    <Grid item xs={2} style={{ textAlign: 'right' }}></Grid>
                                </Grid>
                            </BoxContent>
                            <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginTop: '10px' }}>
                                <SmallButton onClick={() => { dialogRef.current.openUrl('https://www.chilimobil.no/kontantkort/'); }}>Les mer</SmallButton>
                                <SmallButton onClick={() => { dialogRef.current.openUrl('https://www.chilimobil.no/sporsmal-hjelp/kontantkort-utlandet/'); }}>Priser til og i utland</SmallButton>
                            </Grid>
                        </Box>}
                    {(state.IsPostpaid || state.IsData || state.UnpaidInvoiceText) &&
                        <Box background fullWidth>
                            <BoxTitle>
                                {state.IsNorway ? 'Ubetalte fakturaer' : 'Obetalda fakturor'}
                            </BoxTitle>
                            <BoxContent>
                                {!state.UnpaidInvoiceText ?
                                    <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={30} width={50} />
                                    :
                                    <Grid container direction="row" justify="space-between" alignItems="center" dangerouslySetInnerHTML={{ __html: state.UnpaidInvoiceText }} />
                                }
                            </BoxContent>
                            <SmallButton component={Link} replace to="/invoice-list" transition="fade">Se mer</SmallButton>
                        </Box>}
                    {(state.IsPrepaid || state.IsPostpaid) && <Box background fullWidth>
                        <BoxTitle>
                            {state.IsNorway ? state.IsPrepaid ? "Kontantkort" : "Abonnement" : "Abonnemang"}
                        </BoxTitle>
                        <BoxContent>
                            <Grid container direction="row" justify="space-between" alignItems="center">
                                <Grid item xs={8}>
                                    {state.IsNorway ? state.IsPrepaid ? 'Du kan enkelt gjøre endringer på ditt kontantkort her.' : 'Du kan enkelt gjøre endringer på ditt abonnement her.' : 'Du kan enkelt ändringar på ditt abonnemang här.'}
                                </Grid>
                                <Grid item xs={4} style={{ textAlign: 'center' }}>
                                    {!state.Subscription ?

                                        <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={30} width={50} />
                                        :
                                        <React.Fragment>
                                            <div style={{ fontFamily: theme.typography.fontFamily, fontStyle: 'normal', fontVariant: 'normal', fontWeight: 400, fontSize: '14px' }}>
                                                {state.Subscription.packageName}
                                            </div>
                                            <div>{state.Subscription.msisdn}</div>
                                        </React.Fragment>}
                                </Grid>
                            </Grid>
                        </BoxContent>
                        <SmallButton component={Link} replace transition="glide-left" to={'/subscriptions/subscription?subscriptionno=' + state.Subscription?.subscriptionNo}>{state.IsNorway ? 'Administrere' : 'Administrera'}</SmallButton>
                    </Box>}
                    {!state.IsData && state.Subscription &&
                        <Box background fullWidth>
                            <BoxTitle>
                                {state.IsNorway ? "Legg til eller endre tjenester" : "Lägg till eller ändra tjänster"}
                            </BoxTitle>
                            <BoxContent>
                                <Grid container direction="row" justify="space-between" alignItems="center">
                                    <Grid item xs={8}>
                                        {state.IsNorway ? 'Legg til eller endre på produkter og tjenester her.' : 'Lägg till eller ändra på produkter och tjänster här.'}
                                    </Grid>
                                </Grid>
                            </BoxContent>
                            <SmallButton component={Link} replace transition="glide-left" to={'/subscriptions/subscription?subscriptionno=' + state.Subscription?.subscriptionNo + '#services'}>{state.IsNorway ? 'Endre' : 'Ändra'}</SmallButton>
                        </Box>}
                </SafeMasonryLayout>
            </TopContainer >
        </>
    );
}